export const map: MapSetup = {
    cells: {
        size: 50,
        wide: 50,
    },
    pan: {
        altMultiplier: 0.2,
        shiftMultiplier: 5,
        step: 1,
    },
    size: 2500,
    startArea: {
        height: 10,
        width: 10,
        x: 20,
        y: 20,
    },
    speed: {
        max: 8,
        min: 1,
    },
    zoom: {
        altMultiplier: 0.2,
        controlStep: 0.1,
        max: 2,
        min: 0.2,
        scrollStep: 0.03,
        shiftMultiplier: 5,
        start: 0.8,
    },
};
